{
  "pending": "Pending",
  "incomplete": "Incomplete",
  "registered": "Registered",
  "deactivated": "Deactivated"
}
